import styled, { css } from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const OptionIcon = styled.svg `
  height: 2rem;
  width: 2rem;
  margin-right: 1rem;

  use {
    fill: var(--primary-darker);
  }
`;
export const OptionTitle = styled.span `
  text-align: left;
  margin-right: 1rem;
`;
export const OptionChevron = styled.svg `
  height: 1.6rem;
  width: 1.6rem;
  transform: rotate(180deg);
  margin-left: auto;
  position: relative;
  top: -.1rem;

  use {
    fill: var(--primary-darker);
  }
`;
export const Option = styled.button `
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: -0.038rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #24195F;
  width: 100%;
  padding: 0;
`;
export const ListItem = styled.li `
  display: flex;
  width: 100%;
  padding: 1rem 0;
  margin-bottom: 0;
`;
export const List = styled.ul `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2.5rem 0 0;
  border-top: 0.1rem solid var(--border);
  margin: 0;
`;
export const Label = styled.button `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  font: var(--heading-three-font);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 0 0 0 2.5rem;
  color: var(--primary-darker);
  position: relative;

  svg {
    margin-right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 1.2rem;
    width: 1.2rem;
    position: absolute;
    cursor: pointer;

    use {
      fill: var(--primary-medium);
    }
  }
`;
export const Element = styled.div `
  //display: flex;
  //flex-direction: column;
  width: 100%;
  height: 100%;

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    padding-bottom: 0;
  }
`;
export const GridItem = styled.div `
  width: 100%;
  cursor: pointer;
`;
export const shortGrid = css `
  max-height: 67rem;
  height: calc(100% - 4.5rem);
  overflow-y: scroll;
  flex-grow: 1;
  position: relative;

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    max-height: calc(100% - 3.9rem);
    height: auto;
  }
`;
export const Grid = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  
  &:nth-child(odd) {
    grid-area: 1 / 1 / 2 / 2;
  }
  
  width: 100%;
  container: activity-grid / normal;


  /* At least 9 (9 or more) children */
  &:has(> :nth-child(9)) {
    ${shortGrid}
  }
  
  @media screen and (max-height: 810px) {
    ${shortGrid}
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    ${shortGrid}
  }
  
  @supports not (:has() {
    ${shortGrid}
  })

  @media screen and (min-width: ${MediaSizes.XS_MAX}px) {
    gap: 2rem;
  }
`;
export default {
    Element,
    Grid,
    GridItem,
    Label,
    List,
    ListItem,
};
